class PluginImpl {
  constructor(config) {
    this.config = config;
  }
  getId() {
    return this.config.id;
  }
  getApis() {
    return this.config.apis ?? [];
  }
  getFeatureFlags() {
    return this.config.featureFlags?.slice() ?? [];
  }
  get routes() {
    return this.config.routes ?? {};
  }
  get externalRoutes() {
    return this.config.externalRoutes ?? {};
  }
  provide(extension) {
    return extension.expose(this);
  }
  toString() {
    return `plugin{${this.config.id}}`;
  }
}
function createPlugin(config) {
  return new PluginImpl(config);
}

export { PluginImpl, createPlugin };
//# sourceMappingURL=Plugin.esm.js.map
